import Payments from './payments'
export default Payments
